<p-dropdown [emptyMessage]="'DATA_MANAGEMENT.NO_RESULTS' | translate"
            [disabled]="!estimates"
            [options]="estimates"
            optionLabel="projectCode"
            [(ngModel)]="selectedEstimate"
            [filter]="true"
            [showClear]="true"
            dataKey="id"
            [placeholder]="'DATA_MANAGEMENT.SELECT_ESTIMATE' | translate"
            [virtualScroll]="true"
            [virtualScrollItemSize]="30"
            [style]="style"
            autoWidth="true"
            [panelStyleClass]="styleClass"
            [styleClass]="styleClass">

  <ng-template pTemplate="selectedItem">
    <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: selectedEstimate }"></ng-container>
  </ng-template>

  <ng-template let-item
               pTemplate="item">
    <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
  </ng-template>
</p-dropdown>

<ng-template #itemTemplate
             let-estimateDto>
  <div *ngIf="estimateDto">
    <i *ngIf="estimateDto.status === StatusEnum.Imported"
       class="far fa-file-import"></i>
    <i *ngIf="estimateDto.hasPCSyncBeenRequested"
       class="far fa-file-export"></i>
    {{ estimateDto.projectCode }}
    ({{ estimateDto.estimateType }})
    <span *ngIf="estimateDto.codeRef">
      {{ estimateDto.codeRef }}
    </span>
  </div>
</ng-template>
